export const tourDashboard = [
  {
    target: ".chat-leftsidebar",
    content: "Esta é a barra lateral, onde você alterna rapidamente entre diferentes conversas ativas.",
    placement: "right",
    disableBeacon: true,
  },
  {
    target: ".chat-conversation",
    content: (
      <div>
        {" "}
        <p>Este é o painel de chat, onde todas as mensagens da conversa selecionada aparecem.</p>{" "}
        <p>Aqui você pode rolar para revisar todo o histórico de mensagens.</p>{" "}
      </div>
    ),
    placement: "left",
  },
  {
    target: "#new-conversation2",
    content: (
      <div>
        {" "}
        <p>Se a conversa foi finalizada, clique aqui para reabrir enviando um modelo aprovado do WhatsApp.</p>{" "}
        <p>Depois de reabrir, você pode continuar a conversa normalmente digitando sua mensagem.</p>{" "}
      </div>
    ),
    placement: "top",
  },
  {
    target: "textarea.form-control",
    content:
      "Digite sua mensagem neste campo. Pressione Enter para criar uma nova linha ou Shift+Enter para enviar imediatamente.",
    placement: "top",
  },
  {
    target: "#emoji",
    content: "Clique aqui para inserir emojis e dar mais expressão às suas mensagens.",
    placement: "top",
  },
  {
    target: "#files",
    content: "Use este botão para anexar documentos e arquivos à sua conversa.",
    placement: "top",
  },
  {
    target: "#images",
    content: "Clique aqui para adicionar imagens às suas mensagens.",
    placement: "top",
  },
  {
    target: "#btnSubmit",
    content: "Envie sua mensagem clicando neste botão ou usando Shift+Enter.",
    placement: "top",
  },
  {
    target: "#quick-messages",
    content: "Acesse mensagens pré-definidas para responder rapidamente a perguntas comuns.",
    placement: "top",
  },
  {
    target: "#department-select",
    content: "Filtre as conversas por departamento para visualizar apenas o que é relevante para sua equipe.",
    placement: "top",
  },
  {
    target: "#searchChatOrUser",
    content: (
      <div>
        {" "}
        <p>Busque conversas ou usuários pelo nome ou ID usando este campo.</p>{" "}
        <p>"Enter" para buscar e "Esc" para cancelar.</p>{" "}
      </div>
    ),
    placement: "top",
  },
  {
    target: "#dropdownFilter",
    content: "Aplique filtros de tags para organizar suas conversas de forma mais eficiente.",
    placement: "top",
  },
  {
    target: "#tags",
    content: "Gerencie suas tags: crie, edite ou remova categorias para suas conversas.",
    placement: "bottom",
  },
  {
    target: "#new-conversation",
    content: "Inicie um novo atendimento clicando neste botão.",
    placement: "bottom",
  },
  {
    target: "#definitions",
    content: "Configure fluxos de autoatendimento para seus clientes por meio desta opção.",
    placement: "bottom",
  },
  {
    target: "#side-menu-nav",
    content: "Neste menu lateral você acessa perfis, chats internos, contatos e outras funcionalidades.",
    placement: "right",
  },
  {
    target: ".profile-user",
    content: "Visualize e edite seu perfil; aqui também está a opção de logout.",
    placement: "bottom",
  },
  {
    target: "#insert_tag",
    content: "Adicione tags à conversa para facilitar futuras buscas e organização.",
    placement: "bottom",
  },
  {
    target: "#chat_transfer",
    content: "Transfira o atendimento para outro atendente/ departamento quando necessário.",
    placement: "bottom",
  },
  {
    target: "#open_user_profile",
    content: "Abra o perfil completo do usuário para ver mais detalhes.",
    placement: "bottom",
  },
  {
    target: "#finish_chat",
    content: "Finalize o atendimento clicando aqui quando a conversa for concluída.",
    placement: "bottom",
  },
  {
    target: "#more_options",
    content: "Encontre opções adicionais, como silenciar notificações e mais configurações.",
    placement: "bottom",
  },
];
